import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "mt-6" }
const _hoisted_3 = { class: "divide-y divide-gray-200" }
const _hoisted_4 = { class: "gap-6 mt-6 md:grid md:grid-cols-4" }
const _hoisted_5 = { class: "sm:col-span-4" }
const _hoisted_6 = { class: "flex justify-center px-6 pt-5 pb-6 mt-1 border-2 border-clay-500 border-dashed rounded-md" }
const _hoisted_7 = { class: "space-y-1 text-center" }
const _hoisted_8 = { class: "bg-white" }
const _hoisted_9 = { class: "py-8 mx-auto sm:py-12" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "grid grid-cols-1 mt-6 gap-x-8 gap-y-8 sm:grid-cols-2 sm:gap-y-10 lg:grid-cols-4" }
const _hoisted_12 = { class: "relative group" }
const _hoisted_13 = { class: "overflow-hidden bg-gray-100 border rounded-lg shadow-lg aspect-square border-slate-900" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "mt-3" }
const _hoisted_16 = { class: "flex items-center justify-between" }
const _hoisted_17 = { class: "mt-3" }

import {onMounted, Ref, ref} from "vue";
import {client, UploadCareSettings} from '@/shared';
import {
    AddProfileHeadshot,
    GetProfileHeadshots,
    GetProfileHeadshotsResponse,
    HeadshotDto,
    MakeProfileHeadshotPrimaryRequest,
    RemoveProfileHeadshotRequest,
} from "@/dtos";
import ErrorSummary from "@/main/components/ErrorSummary.vue";
import NotificationSuccess from "@/main/components/NotificationSuccess.vue";
import {Switch} from '@headlessui/vue';
import {trackEvent} from '@/shared';
import * as UC from '@uploadcare/file-uploader';
import "@uploadcare/file-uploader/web/uc-file-uploader-inline.min.css"
import SaButton from "@/main/components/SaButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ProfileHeadshotsSettings',
  setup(__props) {

UC.defineComponents(UC);

const responseStatus = ref(null);
const headshots: Ref<HeadshotDto[]> = ref([]);

const updateSuccessful: Ref<Boolean> = ref(false);

onMounted(async () => {
    await getHeadshots();
});

const getHeadshots = async () => {
    await client.get<GetProfileHeadshotsResponse>(new GetProfileHeadshots())
        .then(response => {
            headshots.value = response.headshots;
        });
}

const handleDoneEvent = async (e: any) => {
    if (e.detail && e.detail.status === "success") {
        const file = e.detail.successEntries[0];
        await onUploadSuccess(file);
        const uploaderCtx = document.querySelector('#uploaderctx')
        const api = uploaderCtx?.getAPI();
        api.removeAllFiles();
    }
}

const onUploadSuccess = async (response: any) => {
    await client.post<GetProfileHeadshotsResponse>(new AddProfileHeadshot({
        fileUrl: response.cdnUrl
    }))
        .then(async (res) => {
            updateSuccessful.value = true;
            responseStatus.value = null;
            headshots.value = res.headshots;

            trackEvent( 'profile_updated', {
                method: 'photo_added'
            });
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
}

const makeHeadshotPrimary = async (headshot: HeadshotDto) => {
    await client.post<GetProfileHeadshotsResponse>(new MakeProfileHeadshotPrimaryRequest({
        photoId: headshot.id
    }))
        .then(async (res) => {
            updateSuccessful.value = true;
            responseStatus.value = null;
            headshots.value = res.headshots;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
}

const isDeleting = ref<Record<string, boolean>>({});
const deleteHeadshot = async (headshot: HeadshotDto) => {
    isDeleting.value[headshot.id] = true;

    await client.delete<GetProfileHeadshotsResponse>(new RemoveProfileHeadshotRequest({
        photoId: headshot.id
    }))
        .then(async (res) => {
            updateSuccessful.value = true;
            responseStatus.value = null;
            headshots.value = res.headshots;
        })
        .catch(e => {
            responseStatus.value = e.responseStatus;
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        })
        .finally(() => {
            isDeleting.value[headshot.id] = true; 
        });
}



return (_ctx: any,_cache: any) => {
  const _component_uc_config = _resolveComponent("uc-config")!
  const _component_uc_upload_ctx_provider = _resolveComponent("uc-upload-ctx-provider")!
  const _component_uc_file_uploader_regular = _resolveComponent("uc-file-uploader-regular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", null, [
        _createVNode(ErrorSummary, { "response-status": responseStatus.value }, null, 8, ["response-status"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[1] || (_cache[1] = _createElementVNode("label", {
                  class: "block text-sm font-medium text-gray-700",
                  for: "cover-photo"
                }, " Photos ", -1)),
                _createVNode(_component_uc_config, {
                  style: {"display":"none"},
                  pubkey: "c1ecae68d0087aa3986a",
                  "ctx-name": "my-uploader",
                  "img-only": "true",
                  multiple: "false",
                  "max-local-file-size-bytes": _unref(UploadCareSettings).maxLocalFileSizeBytes,
                  "crop-preset": "1:1",
                  "image-shrink": "400x400",
                  "confirm-upload": "true",
                  "remove-copyright": "true",
                  "source-list": _unref(UploadCareSettings).sourceList
                }, null, 8, ["max-local-file-size-bytes", "source-list"]),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_uc_upload_ctx_provider, {
                      id: "uploaderctx",
                      "ctx-name": "my-uploader",
                      onDoneClick: handleDoneEvent
                    }),
                    _createVNode(_component_uc_file_uploader_regular, {
                      "ctx-name": "my-uploader",
                      class: "uc-light"
                    }, {
                      default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createElementVNode("p", { class: "text-xs text-clay-800" }, " PNG, JPG, GIF up to 4MB ", -1)
                      ])),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "space-x-4" }, [
              _createElementVNode("h2", { class: "text-lg font-medium text-gray-900" }, "Your Headshots")
            ], -1)),
            (headshots.value?.length < 1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, " The world wants to see you! Please upload your headshot. "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(headshots.value, (headshot) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("img", {
                      src: headshot.fileName,
                      class: "object-cover object-center",
                      alt: "Headshot thumbnail"
                    }, null, 8, _hoisted_14)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "flex flex-col flex-grow" }, [
                        _createElementVNode("span", {
                          id: "primaryHeadshot-label",
                          class: "text-sm font-medium text-gray-900"
                        }, "Primary")
                      ], -1)),
                      _createVNode(_unref(Switch), {
                        modelValue: headshot.isHeadshot,
                        "onUpdate:modelValue": ($event: any) => ((headshot.isHeadshot) = $event),
                        class: _normalizeClass([headshot.isHeadshot ? 'bg-powder-600' : 'bg-gray-200', 'relative inline-flex shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-powder-500']),
                        onClick: _withModifiers(($event: any) => (makeHeadshotPrimary(headshot)), ["prevent"])
                      }, {
                        default: _withCtx(() => [
                          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "sr-only" }, "Primary", -1)),
                          _createElementVNode("span", {
                            class: _normalizeClass([headshot.isHeadshot ? 'translate-x-5' : 'translate-x-0', 'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow-sm transform ring-0 transition ease-in-out duration-200']),
                            "aria-hidden": "true"
                          }, null, 2)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "class", "onClick"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(SaButton, {
                      onClick: _withModifiers(($event: any) => (deleteHeadshot(headshot)), ["prevent"]),
                      loading: isDeleting.value[headshot.id],
                      variant: "ghost"
                    }, {
                      loading: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" Deleting photo... ")
                      ])),
                      default: _withCtx(() => [
                        _cache[5] || (_cache[5] = _createTextVNode(" Delete photo "))
                      ]),
                      _: 2
                    }, 1032, ["onClick", "loading"])
                  ])
                ]))
              }), 256))
            ])
          ])
        ])
      ])
    ]),
    _createVNode(NotificationSuccess, {
      show: updateSuccessful.value,
      content: "Your changes were successfully saved.",
      title: "Successfully saved!"
    }, null, 8, ["show"])
  ], 64))
}
}

})